module.exports = "/images/skelleftea_kraft_ab.png?ba6b3280d143a2aacb97286262e22ff8";